import { JournalEntryTable } from './JournalEntryTable';

export default JournalEntryTable;
